// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_4x-6";
export var headerCell = "_4x-2";
export var loadingStateContent = "_4x-8";
export var rowWrapper = "_4x-4";
export var stickyAggregationCell = "_4x-b";
export var stickyAggregationRow = "_4x-7";
export var stickyColumnCell = "_4x-a";
export var stickyColumnHeaderCell = "_4x-9";
export var table = "_4x-1";
export var virtualRowWrapper = "_4x-5";
export var virtualTableContainer = "_4x-0";
export var white = "_4x-3";